import { CheckoutState } from '../../state';
import { GooglePayScriptStatus } from '../../state/googlePay';

export const getCanMakePaymentsWithGooglePay = (state: CheckoutState) =>
    !!state.googlePay.canMakePaymentsWithGooglePay;

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;

export const getGooglePayScriptStatus = (state: CheckoutState) =>
    state.googlePay.googlePayScriptStatus;

export const hasErrorInGooglePay = (state: CheckoutState) =>
    state.googlePay.hasError;

export const isGooglePayScriptLoaded = (state: CheckoutState) =>
    state.googlePay.googlePayScriptStatus === GooglePayScriptStatus.loaded;

export const getIsMakingGooglePayPayment = (state: CheckoutState) =>
    state.googlePay.isMakingGooglePayPayment;
